import { AlignmentType, Paragraph, TextRun } from "docx";


export const observation1 = new Paragraph({
    spacing: { line: 276, after: 20 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "This section of the report provides mitigation steps for the identified vulnerabilities.",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})

export const observation2 = new Paragraph({
    spacing: { line: 276, },
    spacing: { after: 500 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The tables below list the vulnerabilities identified, their Severity, Detailed observation and the remediation actions to be performed. The scale as mentioned in Section 7.0 has been used to rate the severity.",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})

export const observation3 = new Paragraph({
    spacing: { before: 400 },
    spacing: { line: 276, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The remediation measures that are listed below should not be implemented on the production systems without prior testing and processing through the proper change management process.",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: false,
            bold: true
        })
    ]
})
